import type { IconData } from '@stacksjs/iconify-core'

export const starCircleFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5\"/><path fill=\"#2859c5\" d=\"m28.586 17.841l-2.81-5.418c-.747-1.439-2.805-1.439-3.552 0l-2.81 5.418l-5.958 1.174c-1.523.3-2.139 2.145-1.101 3.3l4.225 4.698l-.776 6.288c-.196 1.584 1.45 2.747 2.878 2.035L24 32.68l5.318 2.655c1.427.712 3.073-.451 2.878-2.035l-.776-6.288l4.225-4.699c1.038-1.154.422-3-1.1-3.3l-5.96-1.173Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default starCircleFlat
